import React, { useState, useEffect } from 'react';
import './ImageEditor.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Canvas from '../Canvas/Canvas';
import { FaDownload } from 'react-icons/fa';
import DownloadImageModel from '../MainCreate/DownloadImageModel';
import { lowQualityToHighQuality } from '../../config/aws';

const ImageEditor = ({ selectedGroup, brushSize, eraserSize, activeButton, creditsAvailable, setCreditsAvailable, setEditUploadedImages }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [mainImage, setMainImage] = useState(selectedGroup[0].src);
    const [showDownloadModal, setShowDownloadModal] = useState(false);


    useEffect(() => {
        if (mainImage.includes("lowQuality")) {
            // console.log("in ImageEditor      mainImage changed fetching high quality images");
            lowQualityToHighQuality(mainImage).then(highQualityUrl => {
                setMainImage(highQualityUrl);
            });
        }
    }, [mainImage]);

    const handleThumbnailClick = (src, index) => {
        setIsLoading(true);
        setSelectedIndex(index);
        setEditUploadedImages([selectedGroup[index]]);
        setMainImage(src);
        // Simulate loading
        setTimeout(() => {
            setIsLoading(false);
        }, 300);
    };

    const handleConfirm = () => {
        // Add your confirmation logic here
        // console.log('Image confirmed:', mainImage);
    };

    const handleReset = () => {
        setMainImage(selectedGroup[0].src);
        setSelectedIndex(0);
    };

    useEffect(() => {
        if (selectedGroup[0].alt !== "Default edit image") {
            setMainImage(selectedGroup[0].src);
            setSelectedIndex(0);
        }
    }, [selectedGroup]);


    return (
        <div className="image-editor-body mt-16 p-4">
            <div className="image-editor-card">
                <div className="editor-grid">
                    <div className="image-tile">
                        <div className="image-wrapper">
                            {isLoading ? (
                                <div className="loading-spinner">
                                    <i className="fas fa-spinner fa-spin"></i>
                                </div>
                            ) : (
                                <div id="mainImage" className="main-image relative">
                                    <Canvas imageUrl={mainImage} brushSize={brushSize} eraserSize={eraserSize} activeButton={activeButton} />
                                    <button
                                        className="z-20 absolute top-4 right-4 bg-white/90 backdrop-blur-sm p-2.5 rounded-full shadow-lg hover:bg-gray-400 transition-all duration-300 transform hover:scale-110 hover:shadow-xl"
                                        onClick={() => setShowDownloadModal(true)}
                                    >
                                        <FaDownload className="text-gray-800 text-lg" />
                                    </button>

                                    {showDownloadModal && (
                                        <div className="absolute inset-0 flex items-center justify-center z-30">
                                            <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={() => setShowDownloadModal(false)} />
                                            <DownloadImageModel onClose={() => setShowDownloadModal(false)} imageData={{ src: mainImage }} creditsAvailable={creditsAvailable} setCreditsAvailable={setCreditsAvailable} />
                                        </div>
                                    )}
                                </div>

                            )}
                        </div>
                    </div>
                    <div className="toolbar-tile">
                        <div className="toolbar">
                            <div className="thumbnail-list">
                                {selectedGroup.map((thumb, index) => (
                                    <img
                                        key={index}
                                        src={thumb.src}
                                        alt={thumb.alt}
                                        className={`thumbnail ${index === selectedIndex ? 'selected' : ''}`}
                                        onClick={() => handleThumbnailClick(thumb.src, index)}
                                    />
                                ))}
                            </div>
                            {/* <div className="button-group">
                                <button className="btn btn-primary" onClick={handleConfirm}>
                                    <i className="fas fa-check"></i>
                                </button>
                                <button className="btn" onClick={handleReset}>
                                    <i className="fas fa-sync-alt"></i>
                                </button>
                                <button className="btn">
                                    <i className="fas fa-times"></i>
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default ImageEditor;
